import './site.scss';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import { AuthComponents } from './modules/index';
import { ViewModelProvider } from './ViewModelProvider';
import App from './app.vue';

// Turn off notice stating you're not in production
Vue.config.productionTip = false;

// Globally register BootstrapVue components
Vue.use(BootstrapVue);
// Globally register custom Auth Server components
Vue.use(AuthComponents);
// Expose the ViewModel service to auth components
Vue.use(ViewModelProvider);

// Create the Vue app
new Vue({ // eslint-disable-line no-new
  el: '#app',
  render: h => h(App)
});
